<template>
  <md-field class="form-group" :class="{'md-invalid': error}">
    <label :for="name" class="input-area-label body-2">{{ label }}</label>
    <md-input
      v-if="tag === 'input'"
      :id="name"
      type="text"
      :maxlength="maxlength"
      :name="name"
      :class="classes"
      :value="value"
      v-on:input="handleInput"
      @focus="isFocus"
      @blur="$emit('inputChanged')"
      ref="customInput"
      :disabled="disabled"
    />

    <md-textarea
      v-else
      :id="name"
      :maxlength="maxlength"
      :name="name"
      :class="classes"
      :value="value"
      v-on:input="handleInput"
      @focus="isFocus"
      ref="customInput"
      @blur="$emit('inputChanged')"
      :disabled="disabled"
    />
    <span v-if="error" class="md-error">{{ error }}</span>
    <span v-if="!error && hint" class="md-helper-text">{{ hint }}</span>
  </md-field>
</template>

<script>
export default {
  name: 'InputArea',
  props: {
    tag: {
      type: String,
      default: 'input',
    },
    label: {
      type: String,
    },
    value: {
      type: [Object, Array, String, Number],
    },
    classes: {
      type: String,
    },
    name: {
      type: String,
    },
    maxlength: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFocused: false
    }
  },
  mounted () {
    if (this.isVisible) {
      this.$nextTick(() => this.$refs.customInput.$el.focus())
      this.isFocused = true;
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e)
    },
    isFocus() {
      this.isFocused = true
    },
    inputChanged () {
      this.$emit('inputChanged')
      this.isFocused = false
    }
  },
};
</script>

<style lang="scss" scoped>

.md-field {
  margin: 0;
  padding: 0;
  font-family: "Futura W01 Book", Arial, Helvetica, sans-serif !important;

  &.md-focused {
    .input-area-label {
      top: -10px;
    }
  }

  .input-area-label {
    top: 14px;
	  left: 16px;

    background-color: $white;
    @include font-styles('Futura W01 Book', 400);
    padding: 0 4px;
  }

  &.md-has-value {

    .input-area-label {
      top: -10px;
    }
  }

  &.md-has-textarea, .md-input {

    textarea {
      resize: none !important;
    }

    &.md-focused {
      .input-area-label {
        top: -10px;
      }
    }

    &.md-has-value {
      .input-area-label {
        top: -10px;
      }

      @include textStyles(13, 20, 0.4);
    }
  }

  &.md-focused,
  &.md-focused.md-has-value {
    label {
      color: $color-blue;
    }
  }
}

.md-field.md-focused .md-input,
.md-field.md-focused .md-textarea,
.md-field.md-focused .md-input:focus,
.md-field.md-focused .md-input:focus {
  border: 2px solid $color-blue;
}
.md-field .md-textarea {
  white-space: pre-wrap;
	overflow-wrap: break-word;
}
.md-field .md-input,
.md-field .md-textarea {
  border: 1px solid $color-grey;
  border-radius: 10px;
  width: 395px;
  height: 48px;
  padding: 10px 16px 10px 18px;
}
.md-field.md-disabled {
  label {
    color: $color-mid-grey;
  }
  .md-input,
  .md-textarea {
    border: 1px solid $color-mid-grey;
    color: $color-mid-grey;
    cursor: not-allowed;
  }
}
.md-helper-text {
  color: $color-grey;
}
.md-helper-text,
.md-error {
  font-size: 12px;
  padding-left: 18px;
}

.md-field {
  &.md-invalid,
  &.md-invalid.md-focused {
    color: $color-red;
    label {
      color: $color-red;
    }
    .md-input,
    .md-textarea &:focus {
      border-color: $color-red;
    }
  }
}
</style>

